import { render, staticRenderFns } from "./rollertable.vue?vue&type=template&id=cce16a88&scoped=true&"
import script from "./rollertable.vue?vue&type=script&lang=js&"
export * from "./rollertable.vue?vue&type=script&lang=js&"
import style0 from "./rollertable.vue?vue&type=style&index=0&id=cce16a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce16a88",
  null
  
)

export default component.exports